import { Observable } from 'rxjs';

/**
 * Первый запрос при старте: организация определяется бэкендом по домену сайта.
 * Успех — пустой ответ; домен не привязан → ApiError(404, 'org_not_found').
 */
export abstract class SiteApi {
  abstract checkDomain(): Observable<void>;
}
